import { render, staticRenderFns } from "./Cn-TY-P.vue?vue&type=template&id=6158a20b&scoped=true&"
import script from "./Cn-TY-P.vue?vue&type=script&lang=js&"
export * from "./Cn-TY-P.vue?vue&type=script&lang=js&"
import style0 from "./Cn-TY-P.vue?vue&type=style&index=0&id=6158a20b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6158a20b",
  null
  
)

export default component.exports